import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get shape
export const getShape = createAsyncThunk("shape/getShape", async (params, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    const { data } = await API.getShape({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all shape
export const getAllShape = createAsyncThunk("shape/getAllShape", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllShape();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("shape/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("shape/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("shape/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageShape({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create shape
export const createShape = createAsyncThunk("shape/createShape", async (data, { rejectWithValue }) => {
  const { name, isActive } = data;
  try {
    const body = JSON.stringify({ name, isActive });
    const { data } = await API.createShape(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateShape = createAsyncThunk("shape/updateShape", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const { name, isActive } = values;
  try {
    const body = JSON.stringify({ name, isActive });
    const { data } = await API.updateShape(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("shape/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
